<template>
  <v-dialog :value="loading" persistent width="300">
    <v-card color="primary" dark>
      <v-card-text>
        Por favor aguarde
        <v-progress-linear indeterminate color="white" class="mb-0" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    loading: Boolean,
  },
}
</script>
